export default "__VITE_ASSET__Q4el0R4c__"